module.exports = __webpack_public_path__ + "img/rain.be5030ca.webp";